/**
 * What a change case alters against the approved revision, behind a fold.
 *
 * @module components/governance/ChangeCaseComparison
 */

import React from "react";

import {
  humanizeRevisionPath,
  revisionCategoryLabel,
  revisionChangeKindLabel,
  revisionChangeSummary,
} from "@/components/shared/diff-labels";
import { Accordion, AccordionItem, Badge } from "@/components/ui";

/** The diff entries the platform returns for a change case. */
type Changes = Parameters<typeof revisionChangeSummary>[0];

export function ChangeCaseComparison({ changes }: { changes: Changes }): React.ReactElement {
  return (
    <Accordion
      id="change-case-comparison-accordion"
      className="mt-4"
      data-testid="change-case-comparison"
    >
      <AccordionItem
        eventKey="changes"
        headingLevel={3}
        title={`Changes from approved revision: ${revisionChangeSummary(changes)}`}
      >
        <ul className="grid gap-2 text-md">
          {changes.slice(0, 20).map((change) => (
            <li key={change.path} className="flex flex-wrap items-center gap-2">
              <Badge size="sm" variant="outline">
                {revisionCategoryLabel(change.category)}
              </Badge>
              <span className="font-medium">{humanizeRevisionPath(change.path)}</span>
              <span className="text-muted">{revisionChangeKindLabel(change.kind)}</span>
            </li>
          ))}
        </ul>
      </AccordionItem>
    </Accordion>
  );
}
